import {useStore} from 'vuex'

export function useData() {
    const store = useStore();
    return {
        get: () => store.getters.data,
        set: (data) => store.commit('setData', {data})
    }
}